'use client'

import Link from 'next/link'
import { isClearSeverity, severityDotClass } from './smartTaskCardHelpers'

/**
 * Single Smart Inbox task card. Renders as <Link> for actionable tasks,
 * <div> for the clear-state sentinel (T8).
 *
 * Props:
 *   task: { id, severity, count, message, href? }
 */
export default function SmartTaskCard({ task }) {
  const clear = isClearSeverity(task.severity)
  const dotClass = `admin-smart-task-card__dot ${severityDotClass(task.severity)}`

  const body = (
    <>
      <span className={dotClass} aria-hidden="true" />
      <span className="admin-smart-task-card__message">{task.message}</span>
      {!clear && <span className="admin-smart-task-card__chevron" aria-hidden="true">›</span>}
    </>
  )

  if (clear) {
    return (
      <div
        className="admin-smart-task-card admin-smart-task-card--clear"
        data-severity={task.severity}
        data-task-id={task.id}
      >
        {body}
      </div>
    )
  }

  return (
    <Link
      href={task.href}
      className="admin-smart-task-card"
      data-severity={task.severity}
      data-task-id={task.id}
      aria-label={task.message}
    >
      {body}
    </Link>
  )
}
